import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

/**
 * 契約情報取得
 */
export namespace ApiTaRe270 {
  // API Name
  export const name: string = 'ApiTaRe270'
  // GET parameters
  export namespace Get {
    export const path: string = '/ta/forecastAchievement'
    // API Request
    export interface Request {
      query: {
        grade: number
        fiscalYear: number
        testMonth: number
        testCount: number
      }
    }

    // API Response
    export interface Response {
      choiceSchoolDetermineListUrl: string
    }
  }

  // API本体
  export class Api extends ApiBase implements Gettable<Get.Request, Get.Response, ResponseError> {
    // GET
    public get<R>(
      params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      // 成功時のレスポンス構造サンプル
      const validationSample: Get.Response = {
        choiceSchoolDetermineListUrl: '',
      }

      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }

      return this.callbackWrapper<Get.Response, ResponseError, R>(
        api.get<Get.Response>(Get.path, { params: params.query }),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
